import { render } from "./DashboardPrincipal.vue?vue&type=template&id=348491af"
import script from "./DashboardPrincipal.vue?vue&type=script&lang=js"
export * from "./DashboardPrincipal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__